var $ = require('jquery');
var _ = require('underscore');
var Marionette = require('marionette');
var DialogSavedFilter = require('DialogFilterSave');
var Entities = require('Entities');
var Labels = EY.Consultation.Labels;
var Resources = EY.Consultation.Resources;
var User = EY.Consultation.CurrentUser;
var FilterType = EY.Consultation.Lookups.FilterType;
var FilterControlType = EY.Consultation.Lookups.FilterControlType;
var StatusType = EY.Consultation.Lookups.StatusType;
var YesNo = [{ id: 'true', text: Labels.Boolean_Yes }, { id: 'false', text: Labels.Boolean_No }];

var enumeration = function (type) {
    return _.chain(Resources.Enumeration).filter(function (e) {
        return e.type === type && !/Blank$/.test(e.id);
    }).map(function (item) {
        return { id: item.id, text: Labels[item.id] };
    }).value();
};

var resource = function (resources, resourcePrefix, resourceAttribute) {
    return resources.map(function (entry) {
        return { id: entry.id, text: resourcePrefix ? Labels[resourcePrefix + entry[resourceAttribute]] : entry.name };
    });
};

var buildFilters = function () {
    var geography = _.chain(Resources.Geography).filter(function (item) {
        return User.roles && User.roles.length > 0 && (new RegExp(User.geography.replace('//', '')).test(item.id) || 
            new RegExp(item.id.replace('//', '')).test(User.geography))    
        }).groupBy('type').value();
    
    var country = _.map(geography.Country, _.clone);
    _.map(country, function (item) {
        // Instead of searching for "/EMEIA/WEM/Algeria/" and "/EMEIA/EuropeWest/Algeria/". 
        // we now search for "/Algeria/" and bring results from both the above geographies.
        // This removes duplicates from the location filter. 
        // The results fetched will depend on the access of a particular user.
        var newId = item.id.split('/');
        item.id = '/' + newId[newId.length - 2] + '/';
        return item;
    });
    return new Backbone.Collection([
        { name: 'recordTypeId', text: Labels.RecordType, type: FilterType.Simple, controlType: FilterControlType.Dropdown, choices: enumeration('RecordType') },
        { name: 'region', template: '{"geographyId":{"$regex":"{{value}}"}}', text: Labels.Region, type: FilterType.Simple, controlType: FilterControlType.Dropdown, choices: _.union(geography.Region, geography.SubCountry) },
        { name: 'country', template: '{"geographyId":{"$regex":"{{value}}"}}', text: Labels.Country, type: FilterType.Simple, controlType: FilterControlType.Dropdown, choices: country },
        { name: 'industryId', template: '{"industryId":{{value}}}', text: Labels.Industry, type: FilterType.Simple, controlType: FilterControlType.Dropdown, choices: resource(Resources.Industry, "Industry_", "id") },
        { name: 'pic', template: '{"approvers":{"$elemMatch":{"approverGroupId" : "PartnerInCharge","givenName": {"$regex":"{{value}}", "$options":"i"}}}}', text: Labels.PartnerInCharge, type: FilterType.Simple, controlType: FilterControlType.Text },
        { name: 'cpp', template: '{"approvers":{"$elemMatch":{"approverGroupId" : "CountryProfessionalPractice","givenName": {"$regex":"{{value}}", "$options":"i"}}}}', text: Labels.ApproverGroup_CountryProfessionalPractice, type: FilterType.Simple, controlType: FilterControlType.Text },
        { name: 'rpp', template: '{"$or":[{"approvers":{"$elemMatch":{"approverGroupId":"RegionalProfessionalPractice","givenName":{"$regex":"{{value}}","$options":"i"}}}},{"approvers":{"$elemMatch":{"approverGroupId":"SubCountryProfessionalPractice","givenName":{"$regex":"{{value}}","$options":"i"}}}}]}', text: Labels.ApproverGroup_RegionalProfessionalPractice, type: FilterType.Simple, controlType: FilterControlType.Text },
        { name: 'clientName', text: Labels.ClientName, type: FilterType.Simple, controlType: FilterControlType.Text },
        { name: 'engagementName', text: Labels.EngagementName, type: FilterType.Simple, controlType: FilterControlType.Text },
        { name: 'type', template: '{"type":"{{value}}"}', textAttribute: "type", text: Labels.Type, type: FilterType.Simple, controlType: FilterControlType.Dropdown, enumType: 'Type' },
        { name: 'subtype', template: '{"subtype":"{{value}}"}', textAttribute: "subtype", text: Labels.Subtopic1, type: FilterType.Simple, controlType: FilterControlType.Dropdown, enumType: 'Subtype' },
        { name: 'subject', template: '{"subject":"{{value}}"}', textAttribute: "subject", text: Labels.Subtopic2, type: FilterType.Simple, controlType: FilterControlType.Dropdown, enumType: 'Subject' },
        { name: 'assignedToGivenName', text: Labels.AssignedTo, type: FilterType.Advance, controlType: FilterControlType.Text },
        { name: 'creatorGivenName', text: Labels.Creator, type: FilterType.Advance, controlType: FilterControlType.Text },
        { name: 'teamMember', template: '{"approvers":{"$elemMatch":{"approverGroupId" : "TeamMember","givenName": {"$regex":"{{value}}", "$options":"i"}}}}', text: Labels.TeamMember, type: FilterType.Advance, controlType: FilterControlType.Text },
        { name: 'eqr', template: '{"approvers":{"$elemMatch":{"approverGroupId" : "EngagementQualityReviewer","givenName": {"$regex":"{{value}}", "$options":"i"}}}}', text: Labels.ApproverGroup_EngagementQualityReviewer, type: FilterType.Advance, controlType: FilterControlType.Text },
        { name: 'app', template: '{"approvers":{"$elemMatch":{"approverGroupId" : "AreaProfessionalPractice","givenName": {"$regex":"{{value}}", "$options":"i"}}}}', text: Labels.ApproverGroup_AreaProfessionalPractice, type: FilterType.Advance, controlType: FilterControlType.Text },
        { name: 'gpp', template: '{"approvers":{"$elemMatch":{"approverGroupId" : "GlobalProfessionalPractice","givenName": {"$regex":"{{value}}", "$options":"i"}}}}', text: Labels.ApproverGroup_GlobalProfessionalPractice, type: FilterType.Advance, controlType: FilterControlType.Text },
        { name: 'NotificationTo', template: '{"approvers":{"$elemMatch":{"approverGroupId" : "RequiredNotification","givenName": {"$regex":"{{value}}", "$options":"i"}}}}', text: Labels.NotificationTo, type: FilterType.Advance, controlType: FilterControlType.Text },
        { name: 'AdvanceApprover', template: '{"approvers":{"$elemMatch":{"approverGroupId" : "AdvanceApprover","givenName": {"$regex":"{{value}}", "$options":"i"}}}}', text: Labels.AdvanceApprover, type: FilterType.Advance, controlType: FilterControlType.Text },
        { name: 'statusTypeId', text: Labels.RecordStatus, type: FilterType.Advance, controlType: FilterControlType.Dropdown, choices: enumeration('StatusType') },
        { name: 'createdOn', text: Labels.CreationDate, type: FilterType.Advance, controlType: FilterControlType.Date },
        { name: 'approvalBy', text: Labels.ApprovalNeededBy, type: FilterType.Advance, controlType: FilterControlType.Date },
        { name: 'completedOn', text: Labels.DateCompleted, type: FilterType.Advance, controlType: FilterControlType.Date },
        { name: 'id', text: Labels.RecordID, type: FilterType.Advance, controlType: FilterControlType.Text },
        { name: 'clientId', text: Labels.ClientCode, type: FilterType.Advance, controlType: FilterControlType.Text },
        { name: 'engagementId', text: Labels.EngagementNumber, type: FilterType.Advance, controlType: FilterControlType.Text },
        { name: 'fiscalYearEnd', text: Labels.FiscalYearEnd, type: FilterType.Advance, controlType: FilterControlType.Date },
        { name: 'office', template: '{"geographyId":{"$regex":"{{value}}"}}', text: Labels.Office, type: FilterType.Advance, controlType: FilterControlType.Dropdown, choices: geography.Office },
        { name: 'auditClient', template: '{"auditClient": {{value}}}', text: Labels.AuditClient, type: FilterType.Advance, controlType: FilterControlType.Dropdown, choices: YesNo },
        { name: 'secRegistrant', template: '{"$and":[{"configuration.DisplaySEC": true},{"secRegistrant": {{value}}}]}', text: Labels.SECRegistrant, type: FilterType.Advance, controlType: FilterControlType.Dropdown, choices: YesNo },
        { name: 'closeMonitoring', template: '{"$and":[{"configuration.DisplayCloseMonitoring": true},{"closeMonitoring": {{value}}}]}', text: Labels.CloseMonitoring, type: FilterType.Advance, controlType: FilterControlType.Dropdown, choices: YesNo },
        { name: 'listedEntity', template: '{"$and":[{"configuration.DisplayListedEntity": true},{"listedEntity": {{value}}}]}', text: Labels.ListedEntity, type: FilterType.Advance, controlType: FilterControlType.Dropdown, choices: YesNo },
        { name: 'nonListedPie', template: '{"$and":[{"configuration.DisplayNonListedPIE": true},{"nonListedPie": {{value}}}]}', text: Labels.NonListedPIE, type: FilterType.Advance, controlType: FilterControlType.Dropdown, choices: YesNo },
        { name: 'accountingStandard', text: Labels.AccountingStandard_Filter, type: FilterType.Advance, controlType: FilterControlType.Dropdown, choices: enumeration('PrimaryAccountingStandardType') },
        { name: 'customField', template: '{"$or":[{"fields":{"$elemMatch":{"answer": {"$regex":"{{value}}", "$options":"i"}}}},{"fields":{"$elemMatch":{"answer":{"$elemMatch":{"selected":true,"id":{"$regex":"{{value}}", "$options":"i"}}}}}}]}', text: Labels.CustomField, type: FilterType.Advance, controlType: FilterControlType.Text },
        { name: 'restricted', template: '{"restricted": {{value}}}', text: Labels.RestrictedRecord, type: FilterType.Advance, controlType: FilterControlType.Dropdown, choices: YesNo }
    ]);
};

var transform = function (options) {
    var filters = options.filters;
    var collection = new Backbone.Collection();
    var simple = filters.filter({ type: FilterType.Simple });
    var other = filters.filter({ type: FilterType.Advance });
    var saved = options.saved;

    collection.add(simple);
    collection.add(new Backbone.Model({ text: Labels.Other, subfilter: new Backbone.Collection(other) }));
    collection.add(new Backbone.Model({ text: Labels.SavedFilters, subfilter: saved }));
    return collection;
};

var Choice = Marionette.View.extend({
    events: {
        'click': 'select',
        'mouseenter': function () { this.$('ul').toggle(true).animate({ scrollTop: 0 }, 0); },
        'mouseleave': function () { this.$('ul').toggle(false); }
    },
    regions: {
        subfilter: { el: '#subfilter', replaceElement: true }
    },
    tagName: 'li',
    template: '#filterChoice',
    ui: {
        arrow: '.fa-chevron-right',
        filter: '#name',
        trash: '.fa-trash-o'
    },
    onRender: function () {
        if (this.model.has('subfilter')) {
            this.$el.addClass('sub-option dropup');
            this.ui.arrow.removeClass('hidden');
        }
    },
    select: function () {
        if (!this.model.has('subfilter')) {
            this.options.selections.add(this.model.clone().set('id', _.now() + ''));
        }
    }
});

var EmptyFilterChoice = Marionette.View.extend({
    tagName: 'li',
    template: '#emptyFilterChoice'
});

var SavedFilterChoice = Choice.extend({
    events: {
        'click @ui.filter': 'select',
        'click @ui.trash': 'remove'
    },
    onRender: function () {
        this.ui.trash.removeClass('hidden');
    },
    select: function () {
        var model = new Backbone.Model(JSON.parse(JSON.stringify(this.model.attributes)));

        this.options.selections.reset(_.each(model.get('selections'), function (selection) {
            if (selection.type === FilterType.Quicklink || selection.type === FilterType.Predefined || selection.type === FilterType.Search) {
                var query = this.options.queries.get(selection.id);
                var text = query.get('type') === FilterType.Quicklink ? ' (' + Labels.MyRecords + ')' : ' (' + Labels.MyGeography + ')';

                selection.filter = query ? query.get('filter') : '';
                selection.text = query ? query.get('text') + text : '';
                if (query.get('type') === FilterType.Search) {
                    query.set('keyword', selection.keyword = selection.value);
                    selection.filter = {};
                    selection.text = query.get('text') + ': ' + selection.value;
                }
            } else {
                var filter = this.options.filters.filter({ name: selection.name });

                selection.template = filter.length ? _.first(filter).get('template') : '';
                selection.text = filter.length ? _.first(filter).get('text') : '';
                if (selection.controlType === FilterControlType.Dropdown) {
                    selection.choices = filter.length ? _.first(filter).get('choices') : '';
                }
            }
        }, this));
    },
    remove: function (e) {
        e.stopPropagation();
        var user = this.options.user;
        var saved = this.options.saved;

        saved.remove(this.model);
        user.save({ preferences: _.extend({}, user.get('preferences'), { filters: saved.toJSON() }) });
    }
});

var Choices = Marionette.CollectionView.extend({
    attributes: {
        id: 'choices'
    },
    buildChildView: function (child, ChildViewClass) {
        var options = _.extend({}, this.options, { model: child });
        var view = new ChildViewClass(options);

        if (child.has('subfilter')) {
            view.on('render', function () {
                view.getRegion('subfilter').show(new Choices(_.extend(options, { collection: child.get('subfilter') })));
            });
        }
        return view;
    },
    className: 'dropdown-menu ey-primary',
    childView: function (model) {
        return model.get('type') === FilterType.Saved ? SavedFilterChoice : Choice;
    },
    emptyView: EmptyFilterChoice,
    tagName: 'ul'
});

var Selection = Marionette.View.extend({
    className: 'applied-filter',
    events: {
        'blur input': 'update',
        'keypress input[type=text]': 'updateOnEnter',
        'click @ui.remove': function () { this.model.collection.remove(this.model); }
    },
    template: '#filterSelection',
    ui: {
        remove: '#remove',
        value: 'input'
    },
    onRender: function () {
        this.ui.value.val(this.model.get('value'));
    },
    update: function (e) {
        this.model.set(this.$(e.target).attr('name'), e.target.value.replace(/([&()!}[~"/{*+:.$^\\|?\]])/g, '\\$1'));
    },
    updateOnEnter: function (e) {
        if (e.keyCode != 13) return;
        this.update(e);
    }
});

var DateSelection = Selection.extend({
    template: '#dateFilterSelection',
    ui: {
        remove: '#remove',
        start: '#start',
        end: '#end'
    },
    onRender: function () {
        var model = this.model;
        var ui = this.ui;

        ui.start.val(model.get('start') ? new Date(model.get('start')).format() : '');
        ui.end.val(model.get('end') ? new Date(model.get('end')).format() : '');
        ui.start.datepicker({ format: 'dd MM yyyy', autoclose: true, todayHighlight: true })
            .on('changeDate', function (e) {
                if (!ui.end.val()) {
                    var date = new Date(e.date);

                    date.setHours(23, 59, 59);
                    ui.end.val(date.format());
                    model.set({ end: date.toISOString() }, { silent: true });
                }
                model.set({ start: e.date.toISOString() });
            });
        ui.end.datepicker({ format: 'dd MM yyyy', autoclose: true, todayHighlight: true })
            .on('changeDate', function (e) {
                var date = new Date(e.date);

                if (!ui.start.val()) {
                    ui.start.val(e.date.format());
                    model.set({ start: e.date.toISOString() }, { silent: true });
                }
                date.setHours(23, 59, 59);
                model.set({ end: date.toISOString() });
            });
    },
    update: function () { /* NOOP! */ }
});

var DropDownMenuItem = Marionette.View.extend({
    tagName: "li",
    className: "dropdown-item menu-item",
    template: "#dropdownFilterSelection",
    ui: {
        "checkbox": "input[type='checkbox']"
    },
    events: {
        "click": function (e) {
            if (!$(e.target).is('[type="checkbox"]')) {
                if (this.ui.checkbox.prop("checked"))
                    this.ui.checkbox.prop("checked", false);
                else
                    this.ui.checkbox.prop("checked", true);
            }
            if (this.ui.checkbox.prop("checked") && this.options.max && (this.model.collection.filter({ selected: true }).length >= this.options.max)) {
                this.ui.checkbox.prop("checked", false);
                return;
            }
            this.ui.checkbox.prop("checked") ? this.model.set("selected", true) : this.model.set("selected", false);

            this.triggerMethod('select:item', this);
            e.stopPropagation();
        }
    },
    templateContext: function () {
        var text = this.options.resourceKeyAttribute ? Labels[this.model.get(this.options.resourceKeyAttribute)] : this.model.get('text');
        var value = this.options.resourceKeyAttribute ? this.model.get(this.options.resourceKeyAttribute) : this.model.get('id');
        _.contains(this.options.valueModel.get("value"), this.model.id)  && this.model.set("selected", true);

        return {
            options: this.options,
            text: text,
            value: value,
            checked: _.contains(this.options.valueModel.get("value"), value) ? "checked" : ""
        };
    }
});

var DropDownMenuCollectionView = Marionette.CollectionView.extend({
    tagName: "ul",
    className: "dropdown-menu textcolor",
    childView: DropDownMenuItem,
    childViewEvents: {
        'select:item': function (childview) {
            this.triggerMethod('child:select:item', childview);
        }
    },
    childViewOptions: function () {
        var options = _.clone(this.options);
        return options;
    },
    itemFilter: function (value) {
        var filter = value && value.toUpperCase();
        _.each(this.$el.find(".menu-item"),
            function (a) {
                if (a.textContent.toUpperCase().indexOf(filter) > -1) {
                    a.style.display = "";
                } else {
                    a.style.display = "none";
                }
            }
        );
    }
});

var MultiSelectDropDownView = Selection.extend({
    template: "#multiSelectLayout",
    ui: {
        'selectedItem': "#selectedItem",
        "selected": "#selected",
        'toggleButton': ".dropdown-toggle",
        remove: '#remove'
    },
    events: {
        'click @ui.remove': function () { this.model.collection.remove(this.model); },
        "shown.bs.dropdown": function () {
            if (!this.ui.selected.is(':focus')) {
                this.ui.selected.focus();
                this.ui.selected.attr("title", Labels.Select);
            }
        },
        "hidden.bs.dropdown": function () {
            this.ui.selected.is(':focus') && this.ui.toggleButton.dropdown('toggle');
        },
        "hide.bs.dropdown": function () {
            this.getChildView('dropdownMenu').itemFilter("");
        },
        "keyup #selected": function () {
            this.getChildView('dropdownMenu') && this.getChildView('dropdownMenu').itemFilter(this.ui.selected.val());
        },
        "focus #selected": function () {
            this.ui.selected.attr("placeholder", "");
            this.ui.toggleButton.attr("aria-expanded") == "false" && this.ui.toggleButton.dropdown('toggle');
        },
        "focusout #selected": function () {
            var selections = _.map(this.collection.where({ selected: true }), function (item) {
                return item.get('text');
            });
            //this.ui.selected.val(selectedText);
            this.ui.selected.val("");
            if (_.any(selections)) {
                var selectedText = selections.toString().replace(/,/g, ", ");
                this.ui.selected.attr("placeholder", selectedText);
                //this.ui.selected.val(selectedText);
                this.ui.selected.attr("title", selectedText);
            } else {
                //this.ui.selected.val(Labels.Select);
                this.ui.selected.attr("placeholder", Labels.Select);
                this.ui.selected.attr("title", Labels.Select);
            }
        }
    },
    regions: {
        dropdownMenu: {
            el: '.dropdown-menu',
            replaceElement: true
        }
    },
    childViewEvents: {
        'child:select:item': 'childItemSelected'
    },
    childItemSelected: function (childView) {
        this.updateButtonDropdownValue(childView.model);
    },
    updateButtonDropdownValue: function () {
        var selections = _.map(this.collection.where({ selected: true }), function (item) {
            return item.get('text');
        });
        var selectionValues = _.map(this.collection.where({ selected: true }), function (item) {
            return item.get('id');
        });
        this.ui.selected.text("");
        this.ui.selected.val("");
        if (_.any(selections)) {
            var selectedText = selections.toString().replace(/,/g, ", ");
            this.ui.selected.attr("placeholder", selectedText);
            //this.ui.selected.val(selectedText);
            this.ui.selected.attr("title", selectedText);
        } else {
            //this.ui.selected.val(Labels.Select);
            this.ui.selected.attr("placeholder", Labels.Select);
            this.ui.selected.attr("title", Labels.Select);
        }

        this.model.set("value", selectionValues ? selectionValues : []);
        this.model.set("valueText", selections ? selections : []);
        //var query = this.options.collection.findWhere({ name: '' });
        //var aggregate = [{ $match: (query ? query.get('filter') : {}) }];
        //var criteria = [];

        //_.chain(this.options.collection.toJSON()).reject({ name: '' }).groupBy('name').each(function (values, key) {

        //    var filter = this.options.filters.findWhere({ name: key });
        //    if (this.model.get("name") === key) {

        //        if (filter.get('controlType') === FilterControlType.Dropdown) {
        //            var selectedValue = this.collection.filter({ selected: true });
        //            var value = [];
        //            _.each(values, function (x) {
        //                _.each(selectedValue, function (val) {
        //                    value.push(JSON.parse(x.template.replace(/{{value}}/g, val.id)));
        //                });
        //            });
        //            value.length > 0 && criteria.push({ $or: value });
        //        } else {
        //            var criterion = {};
        //            var regex = this.collection.filter({ selected: true });
        //            var regexValue = _.pluck(regex, 'id').join('|');
        //            if (regexValue) {
        //                criterion[key] = { $regex: regexValue, $options: 'i' };
        //                criteria.push(criterion);
        //            }
        //        }
        //    } else {
        //        if (filter.get('controlType') === FilterControlType.Dropdown) {
        //            var existingValue = [];
        //             _.chain(values).reject(function (x) { return !x.value; }).map(function (x) {
        //                 _.each(x.value, function (val) {
        //                     existingValue.push(JSON.parse(x.template.replace(/{{value}}/g, val)));
        //                });
        //            }).value();

        //            if (existingValue.length) {
        //                criteria.push({ $or: existingValue });
        //            }
        //        } else {
        //            var regexCriterias = [];
        //            _.each(values, function (x) {
        //                _.each(x.value, function (val) {
        //                    var criterion = {};
        //                    if (val) {
        //                        criterion[key] = { $regex: val, $options: 'i' };
        //                        regexCriterias.push(criterion);
        //                    }
        //                });

        //            });
        //            if (regexCriterias.length) {
        //                criteria.push({ $or: regexCriterias });
        //            }

        //        }
        //    }
        //}, this).value();
        //if (criteria.length) {
        //    aggregate.push({ $match: { $and: criteria } });
        //}
        //if (query && query.get('type') === FilterType.Search && query.get('keyword')) {
        //    this.options.queries.findWhere({ type: FilterType.Search }).set('saved-search', aggregate);
        //} else {
        //    this.options.queries.get('').set({ selected: false }).set({ aggregate: aggregate, selected: true });
        //}
    },
    onRender: function () {
        this.collection = new Backbone.Collection(this.model.get('choices'), { comparator: 'text' });
        if (!this.model.get('choices')) {
            this.classifications();
        }

        this.showChildView("dropdownMenu", new DropDownMenuCollectionView({ collection: this.collection ,valueModel:this.model}));
    },
    onAttach: function () {
        if (this.model.get('valueText')) {
            var selectedText = this.model.get('valueText').toString().replace(/,/g, ", ");
            this.ui.selected.attr("placeholder", selectedText);
            this.ui.selected.attr("title", selectedText);
        } else {
            this.ui.selected.attr("placeholder", Labels.Select);
            this.ui.selected.attr("title", Labels.Select);
        }
    },
    classifications: function () {
        var context = this;
        var records = new Entities.Records();
        var attribute = this.model.get('name');
        var select = {};
        var query = context.model.collection.findWhere({ name: '' });
        var group = { _id: { id: "$" + attribute } };
        var filter = query.get('filter') || { $or: [{ createdBy: User.upn }, { 'approvers.upn': User.upn, statusTypeId: { $ne: StatusType.Draft } }, { assignedTo: User.upn, statusTypeId: StatusType.Preparation }, { statusTypeId: { $ne: StatusType.Draft }, geographyId: { $regex: User.geographyByRole['CountryProfessionalPractice'] + '|' + User.geographyByRole['Reviewer'] } }, { geographyId: { $regex: User.adminGeography } }] };

        select[attribute] = 1;
        records.fetch({
            aggregate: [{
                $match: filter
            }, { $project: select }, { $group: group }, { $project: { _id: 0, id: "$_id.id", text: "$_id.id" } }]
        }).done(function () {
            context.collection.reset(records.filter(function (r) {
                return r.id;
            }));
        });
    },
    templateContext: function () {
        return {
            options: this.options
        };
    }
});


var FilterSelection = Selection.extend({
    template: '#quicklinkFilterSelection'
});

var Selections = Marionette.CollectionView.extend({
    childView: function (model) {
        switch (model.get('controlType')) {
            case FilterControlType.Text:
                view = Selection;
                break;
            case FilterControlType.Dropdown:
                view = MultiSelectDropDownView;
                break;
            case FilterControlType.Date:
                view = DateSelection;
                break;
            default:
                view = FilterSelection;
                break;
        }
        return view;
    },
    childViewOptions: function () {
        var options = _.clone(this.options);
        return options;
    },
    filter: function (child) {
        return child.get('controlType') !== '';
    }
});


var Layout = Marionette.View.extend({
    collectionEvents: {
        'add': 'reset',
        'change': 'run',
        'remove reset': 'remove'
    },
    events: {
        'click @ui.clear': function () { this.collection.reset(this.collection.first()); },
        'click @ui.menu': function () { this.$('.sub-option ul').toggle(false); },
        'click @ui.save': 'save'
    },
    regions: {
        filters: { el: '#filters', replaceElement: true },
        selections: '#selections'
    },
    template: '#filterLayout',
    ui: {
        actions: '#filterActions',
        apply: '#apply',
        clear: '#clear',
        menu: '#menu',
        save: '#save',
        selections: '#selections'
    },
    remove: function () {
        this.reset();
        if (this.collection.length == 1) {
            var filter = this.collection.first();
            this.options.queries.get(filter.get('type') === FilterType.Search ? 'PendingMyAction' : this.collection.first().id).set({ selected: false }).set({ selected: true });
        } else { this.run(); }
    },
    reset: function () {
        var selection = this.collection.any(function (x) {
            return x.get('type') !== FilterType.Predefined && x.get('type') !== FilterType.Quicklink && x.get('type') != FilterType.Search;
        });

        this.ui.selections.toggleClass('hidden', !selection);
        this.ui.actions.toggleClass('hidden', !selection);
        if (selection) {
            this.options.queries.any(function (query) { query.get('selected') && query.set('selected', false); });
            if (this.options.collection.length == 2) {
                var filter = _.first(this.options.collection.models).get('filter');
                this.options.queries.get('').set({ aggregate: [{ $match: filter }] });
            }
        }
    },
    run: function () {
        var query = this.collection.findWhere({ name: '' });
        var aggregate = [{ $match: (query ? query.get('filter') : {}) }];
        var criteria = [];

        _.chain(this.collection.toJSON()).reject({ name: '' }).groupBy('name').each(function (values, key) {
            var criterion = {};
            var filter = this.options.filters.findWhere({ name: key });

            if (filter.get('controlType') === FilterControlType.Date) {
                var last = _.last(values);

                if (last) {
                    criterion[key] = { $gte: last.start || last.end, $lte: last.end || last.start };
                    criteria.push(criterion);
                }
            }else if (filter.get('controlType') === FilterControlType.Dropdown) {
                if (filter.has('template')) {
                    var existingValue = [];
                    _.chain(values).reject(function (x) { return !x.value; }).map(function (x) {
                        _.each(x.value, function (val) {
                            existingValue.push(JSON.parse(x.template.replace(/{{value}}/g, val)));
                        });
                    }).value();

                    if (existingValue.length) {
                        criteria.push({ $or: existingValue });
                    }
                } else {
                    var regexCriterias = [];
                    _.each(values, function (x) {
                        _.each(x.value, function (val) {
                            var criterion = {};
                            if (val) {
                                criterion[key] = { $regex: val, $options: 'i' };
                                 regexCriterias.push(criterion);
                            }
                        });

                    });
                    if (regexCriterias.length) {
                        criteria.push({ $or: regexCriterias });
                    }

                }
            }else if (filter.has('template')) {
                var value = _.chain(values).reject(function (x) { return !x.value; }).map(function (x) {
                    return JSON.parse(x.template.replace(/{{value}}/g, x.value));
                }).value();

                if (value.length) {
                    criteria.push({ $or: value });
                }
            }else {
                var regex = _.chain(values).reject(function (x) { return !x.value; }).pluck('value').uniq().value().join('|');

                if (regex) {
                    criterion[key] = { $regex: regex, $options: 'i' };
                    criteria.push(criterion);
                }
            }
        }, this).value();
        if (criteria.length) {
            aggregate.push({ $match: { $and: criteria } });
        }
        if (query && query.get('type') === FilterType.Search && query.get('keyword')) {
            this.options.queries.findWhere({ type: FilterType.Search }).set('saved-search', aggregate);
        } else {
            this.options.queries.get('').set({ selected: false }).set({ aggregate: aggregate, selected: true });
        }
    },
    save: function () {
        var saved = this.options.saved;
        var user = this.options.user;
        var selections = new Backbone.Collection(this.collection.map(function (x) {
            return new Backbone.Model({
                id: x.id, end: x.get('end'), name: x.get('name'), textAttribute: x.get('textAttribute'), start: x.get('start'), type: x.get('type'), controlType: x.get('controlType'), value: x.get('value'), valueText: x.get('valueText')
            });
        }));
        var model = new Backbone.Model({ selections: selections.toJSON(), type: FilterType.Saved });

        DialogSavedFilter.show({
            model: model
        }).always(function () {
            if (model.id) {
                saved.remove(model);
                saved.add(model);
                user.save({ preferences: _.extend({}, user.get('preferences'), { filters: saved.toJSON() }) });
            }
        });
    }
});

module.exports.show = function (options) {
    options = _.extend(options, { saved: new Backbone.Collection(), user: User.model, filters: buildFilters() });

    var region = options.region;
    var queries = options.queries;
    var collection = transform(options);
    var saved = options.saved;
    var user = options.user;
    var selections = new Backbone.Collection();
    var session = User.session;
    var layout = new Layout(_.extend({}, options, {
        collection: selections
    }));

    region.show(layout);
    layout.getRegion('filters').show(new Choices(_.extend({}, options, { collection: collection, selections: selections })));
    layout.getRegion('selections').show(new Selections({ collection: selections, queries: queries, filters: options.filters }));
    queries.on('change:selected', function (query) {
        if (query.get('selected') && query.get('type')) {
            var sessionFilters = session.get('filters');
            var text = query.get('type') === FilterType.Quicklink ? ' (' + Labels.MyRecords + ')' : (query.get('type') === FilterType.Search ? ': ' + query.get('keyword') : ' (' + Labels.MyGeography + ')');

            if (sessionFilters && sessionFilters.length > 1) {
                if (query.get('type') === FilterType.Search) {
                    var selection = _.findWhere(sessionFilters, { name: '' });

                    query.set('keyword', selection.keyword = selection.value);
                }
                selections.reset(sessionFilters);
                session.set('filters', []);
            } else {
                selections.length > 0 && selections.reset();
                selections.add(new Backbone.Model({
                    id: query.id,
                    filter: query.get('filter'),
                    name: '',
                    text: query.get('text') + text,
                    type: query.get('type'),
                    value: query.get('keyword')
                }));
            }
        }
    });

    saved.reset(user.has('preferences') ? user.get('preferences').filters : null);
    layout.on('destroy', function () {
        if (selections.length > 0) {
            session.set('filters', selections.toJSON());
        }
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Home/HomeFilters.js